import { z } from '@harvestiq/zod';
import { dbClaimDocumentSchema } from './db-claim-documents';

export const claimDocumentWithUploadUrlSchema = dbClaimDocumentSchema.extend({
  uploadUrl: z.string().url(),
});

export type ClaimDocumentWithUploadUrl = z.infer<
  typeof claimDocumentWithUploadUrlSchema
>;
